import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { HEADER_HEIGHT } from '../styles';

interface StyledHeaderButtonProps {
	disabled: boolean;
	width: string;
	height: string;
	color?: string;
}

const StyledHeader = styled('div')`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${HEADER_HEIGHT}px;
	background-color: ${NewStyleColor.Grey950};
	font-family: HelveticaNeue, sans-serif;
	color: ${NewStyleColor.White};
`;

const StyledHeaderButton = styled('button').attrs({
	type: 'button',
})`
	padding: 15px;
	border: 0;
	outline: 0;
	background-color: ${NewStyleColor.Grey950};
	color: ${(props: StyledHeaderButtonProps) => props.color
		? props.color
		: NewStyleColor.White
	};
	cursor: pointer;

	${(props: StyledHeaderButtonProps) => props.disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	svg {
		width: ${(props: StyledHeaderButtonProps) => props.width};
		height: ${(props: StyledHeaderButtonProps) => props.height};
		fill: currentColor;
	}
`;

export {
	StyledHeader,
	StyledHeaderButton,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Header/styles.ts